import { UserResponse } from '../../../providers/User/User.model';

export enum EQUIPMENT_FILE_STATUS {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  EXPIRING_WITHIN_30_DAYS = 'EXPIRING_WITHIN_30_DAYS'
}

export interface EquipmentFile {
  id: string;
  equipment_id: string;
  equipment_file_type_id: string;
  equipment_file_type: EquipmentFileType;
  status: EQUIPMENT_FILE_STATUS | null;
  expiration_date: Date | null;
  equipment_file_attachments: EquipmentFileAttachment[];
}

export interface EquipmentFileType {
  id: string;
  name: string;
  description: string;
  is_default: boolean;
}

export type CreateEditEquipmentFileType = Pick<EquipmentFileType, 'name' | 'description'>;
export type UpdateEquipmentFileData = Pick<EquipmentFile, 'expiration_date'>;

export type DeleteEquipmentFileResponse = {
  message: string;
};

export interface EquipmentFileAttachment {
  id: string;
  equipment_file_id: string;
  attachment_id: string;
  tenant_id: string;
  attachment: AttachmentFile;
  created_at?: Date;
  created_by?: string;
  createdBy?: UserResponse;
}

export interface AttachmentBasicProps {
  file_type: string;
  id: string;
  created_at: string;
  created_by: string;
}

export type AttachmentFile = File & AttachmentBasicProps;

export interface EquipmentFileAttachmentParams {
  attachments: AttachmentFile[];
}

export interface EquipmentFileAttachmentsResponse {
  total: number;
  data: EquipmentFileAttachment[];
}
